import { Document, MARKS, BLOCKS, INLINES } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Styled } from './';
import { ReactNode } from 'react';
import { renderBoldText } from './ContentfulRichTextHTML.helper';

const ContentfulRichTextHTML = ({
  document,
}: {
  document: Document | undefined;
}) => {
  const options = {
    renderMark: {
      [MARKS.BOLD]: (text: ReactNode) => renderBoldText(text),
    },
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node: any) => {
        const alt = node.data.target.fields.title || '';
        const url = node.data.target.fields.file.url || '';
        console.log(node);
        return `<img alt="${alt}" src="${url}" />`;
      },
      [INLINES.HYPERLINK]: (node: any) => {
        const url = node.data.uri;
        const text = node.content[0].value;
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a>`;
      },
    },
  };
  const formattedHtmlString = document
    ? documentToHtmlString(document, options)
    : '';

  return (
    <Styled.StyledRichTextContainer
      dangerouslySetInnerHTML={{
        __html: formattedHtmlString,
      }}
    />
  );
};

export default ContentfulRichTextHTML;
